<img src="assets/img/logo_big.svg" alt="Logo der Österreichischen Apothekerkammer"/>
<p>{{ errorHeadlineString | translate }}</p>
<div class="error-text">{{ errorString | translate }}</div>
<app-button (click)="retry()" label="{{'ERROR.BUTTON' | translate}}"></app-button>

